/**
 * Post Teaser Template
 *
 * Editorial-style blog post preview.
 * Root namespace: .post-teaser
 * Modifier: .post-teaser.compact — denser layout for parent slots (e.g. view-post footer)
 */
module.exports = function (app, mod, post) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var data = {};
  var timestamp = null;
  var postId = '';
  var publicKey = '';
  if (post && post.msg) {
    var msg = post.returnMessage ? post.returnMessage() : post.msg;
    data = msg.data || {};
    timestamp = post.timestamp || data.timestamp || null;
    postId = post.signature || post.id || '';
    publicKey = post.from && post.from.length > 0 ? post.from[0].publicKey : '';
  } else {
    data = post || {};
    timestamp = post.timestamp || null;
    postId = post.id || post.signature || post.sig || '';
    publicKey = post.publicKey || post.author && post.author.publicKey || post.author || '';
  }
  var title = data.title || 'Untitled post';
  var subtitle = data.subtitle || null;
  var summary = data.summary || data.excerpt || null;
  var image = data.image || null;
  var imageUrl = data.imageUrl || null;
  var displayImage = imageUrl || '/saito/img/dreamscape.png';
  if (image && !imageUrl) {
    var mimeType = 'image/png';
    displayImage = "data:image/".concat(mimeType, ";base64,").concat(image);
  }
  var dateString = null;
  if (timestamp && app.browser.formatDate) {
    var date = app.browser.formatDate(timestamp);
    if (date) {
      dateString = "".concat(date.month, " ").concat(date.day, ", ").concat(date.year);
    }
  }
  var description = subtitle || summary;
  var displayDescription = null;
  if (description) {
    var maxLength = 120;
    displayDescription = description.length > maxLength ? description.substring(0, maxLength).trim() + '...' : description;
  }
  var compact = options.compact === true;
  var rootClass = compact ? 'post-teaser compact' : 'post-teaser';
  return "\n    <article class=\"".concat(rootClass, "\" data-tx-signature=\"").concat(postId, "\" data-post-id=\"").concat(postId, "\" data-public-key=\"").concat(publicKey, "\">\n      <div class=\"image\">\n        <img src=\"").concat(app.browser.escapeHTML(displayImage), "\" alt=\"").concat(app.browser.escapeHTML(title), "\" />\n      </div>\n\n      <div class=\"content\">\n        <h3 class=\"title\">").concat(app.browser.escapeHTML(title), "</h3>\n\n        ").concat(displayDescription ? "\n          <p class=\"excerpt\">".concat(app.browser.escapeHTML(displayDescription), "</p>\n        ") : '', "\n\n        ").concat(dateString ? "\n          <div class=\"meta\">\n            <time class=\"date\">".concat(dateString, "</time>\n          </div>\n        ") : '', "\n      </div>\n    </article>\n  ");
};